/**
 * Computes the marquee's animation-duration from the real (single-set)
 * content width and a pixels-per-second speed, so a short announcement and
 * a long one both move at the same readable pace instead of one crawling
 * and one racing -- rather than a fixed seconds value that would do that.
 *
 * A custom element (not a DOMContentLoaded listener) specifically because
 * Shopify's Theme Editor removes and re-inserts a section's DOM on every
 * edit -- connectedCallback re-runs automatically when that happens,
 * DOMContentLoaded would not fire again.
 */
class AnnouncementTicker extends HTMLElement {
  static SPEEDS_PX_PER_SECOND = { slow: 30, normal: 50, fast: 70 };
  static MIN_DURATION_SECONDS = 8;

  connectedCallback() {
    this.track = this.querySelector('.announcement-ticker__track');
    this.set = this.querySelector('.announcement-ticker__set');
    if (!this.track || !this.set) return;

    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.onResize = this.measure.bind(this);

    this.measure();
    window.addEventListener('resize', this.onResize);
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.onResize);
  }

  measure() {
    // CSS already disables the animation for reduced motion; skip the
    // measurement work entirely rather than compute a duration nothing uses.
    if (this.reducedMotion.matches) return;

    const speed =
      AnnouncementTicker.SPEEDS_PX_PER_SECOND[this.dataset.speed] || AnnouncementTicker.SPEEDS_PX_PER_SECOND.normal;
    const width = this.set.offsetWidth;
    if (!width) return;

    const duration = Math.max(width / speed, AnnouncementTicker.MIN_DURATION_SECONDS);
    this.track.style.setProperty('--ticker-duration', `${duration}s`);
  }
}

customElements.define('announcement-ticker', AnnouncementTicker);
